import React, { useEffect, useRef, useState } from "react";
import { TypeAnimation } from "react-type-animation";

import { motion } from "motion/react";
import { ActionButton } from "../component/buttons";
import { randomNumber } from "./statsIntro";
import { Counter } from "../component/counter";

export const TracksPlayedBackground = ({ data }) => {
  const floatingAnimation = {
    x: [0, randomNumber(4, 12), 0],
    y: [0, randomNumber(5, 9), 0], // Move up by 20px, then back to original
    transition: {
      duration: 10, // Duration of one cycle
      ease: "easeInOut",
      repeat: Infinity, // Loop indefinitely
    },
    exit: {
      y: "-150%",
    },
  };

  const floatingAnimation2 = {
    x: [randomNumber(6, 15), 0, randomNumber(6, 15), 0],
    y: [randomNumber(0, 9), 0, randomNumber(0, 9), 0], // Move up by 20px, then back to original
    transition: {
      duration: 10, // Duration of one cycle
      ease: "easeInOut",
      repeat: Infinity, // Loop indefinitely
    },
    exit: {
      y: "-150%",
    },
  };

  if (data.top_songs) {
    return <div></div>;
  }

  return (
    <motion.div className="track-played-background">
      <div className="tracks-played-images">
        {data && data.top_songs && data.top_songs.length > 0 && (
          <motion.img
            referrerPolicy="no-referrer"
            className="cover-background cover-background--small"
            src={data.top_songs[0].song_id.artwork}
            alt={data.top_songs[0].song_id.name}
            animate={floatingAnimation2}
          />
        )}

        {data && data.top_songs && data.top_songs.length > 1 && (
          <motion.img
            referrerPolicy="no-referrer"
            className="cover-background cover-background--medium"
            src={data.top_songs[1].song_id.artwork}
            alt={data.top_songs[1].song_id.name}
            animate={floatingAnimation}
          />
        )}

        {data && data.top_songs && data.top_songs.length > 2 && (
          <motion.img
            referrerPolicy="no-referrer"
            className="cover-background cover-background--tiny"
            src={data.top_songs[2].song_id.artwork}
            alt={data.top_songs[2].song_id.name}
            animate={floatingAnimation2}
          />
        )}

        {data && data.top_songs && data.top_songs.length > 3 && (
          <motion.img
            referrerPolicy="no-referrer"
            className="cover-background cover-background--large"
            src={data.top_songs[3].song_id.artwork}
            alt={data.top_songs[3].song_id.name}
            animate={floatingAnimation}
          />
        )}

        {data && data.top_songs && data.top_songs.length > 4 && (
          <motion.img
            referrerPolicy="no-referrer"
            className="cover-background cover-background--xl"
            src={data.top_songs[4].song_id.artwork}
            alt={data.top_songs[4].song_id.name}
            animate={floatingAnimation2}
          />
        )}

        {data && data.top_songs && data.top_songs.length > 5 && (
          <motion.img
            referrerPolicy="no-referrer"
            className="cover-background cover-background--mediumAlt"
            src={data.top_songs[5].song_id.artwork}
            alt={data.top_songs[5].song_id.name}
            animate={floatingAnimation}
          />
        )}

        {data && data.top_songs && data.top_songs.length > 6 && (
          <motion.img
            referrerPolicy="no-referrer"
            className="cover-background cover-background--mediumAlt2"
            src={data.top_songs[6].song_id.artwork}
            alt={data.top_songs[6].song_id.name}
            animate={floatingAnimation2}
          />
        )}

        {data && data.top_songs && data.top_songs.length > 7 && (
          <motion.img
            referrerPolicy="no-referrer"
            className="cover-background cover-background--mediumAlt3"
            src={data.top_songs[7].song_id.artwork}
            alt={data.top_songs[7].song_id.name}
            animate={floatingAnimation}
          />
        )}

        <motion.img
          referrerPolicy="no-referrer"
          className="floating-badge"
          src={require("../assets/img/shape-stats-4.svg")}
        />
      </div>
    </motion.div>
  );
};

export const TracksPlayed = ({ data, next }) => {
  const [hide, setHide] = useState(false);
  const [showResult, setShowResult] = useState(true);

  const minutes = Math.floor(data.minutes / 24 / 60);

  if (!data.play_count) {
    next();
  }

  return (
    <motion.div className="app-stats-intro-content" key="step-track-played">
      <TracksPlayedBackground data={data} />
      <div
        className="center-container track-count-container"
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: "0%" }}
        exit={{ opacity: 0, y: "-400%" }}
        transition={{
          duration: 1.0,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        <motion.div
          className="column-layout "
          initial={{ opacity: 0, y: "100%" }}
          animate={{
            opacity: showResult ? 1 : 0,
            y: showResult ? "0%" : "100%",
          }}
          exit={{ opacity: 0, y: "-400%" }}
          transition={{
            duration: 1.0,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <div className="column-layout tracks-played">
            <Counter
              className="headline counter-track"
              from={0}
              to={data.play_count}
              duration={3}
            />
            <h3 className="light-headline">tracks played</h3>

            <TypeAnimation
              className="track-played-description"
              sequence={[
                "",
                3000,
                "Listening to " +
                  data.play_count +
                  " songs is like having your own epic music festival that lasts non-stop for about " +
                  minutes +
                  " days!",
                500,
              ]}
              typeSpeed={620}
            />
            <p></p>
          </div>
        </motion.div>

        <button
          onClick={() => next()}
          style={{
            marginBottom: "32px",
          }}
        >
          <ActionButton title="next" />
        </button>
      </div>
    </motion.div>
  );
};
